module.exports = __webpack_public_path__ + "static/media/xingzhengbankuai.95706a7f.png";